import { connect } from 'react-redux';
import { AIRCRAFT_TYPE_OPTIONS_W_ALL, NOT_AVAILABLE } from 'constants';
import { Row, Col, Button } from 'react-bootstrap';
import Select from 'components/inputs/Select';
import PropTypes from 'prop-types';
import SkyPulseTable from 'components/SkyPulseTable';
import { getUTCDateTime } from 'utils';

import styles from './styles.module.css';

const columns = [
  {
    name: 'Tail',
    key: 'tail',
    sortable: true,
    size: 'xsmall',
    dataCyClassName: 'Ship-ShipSelectTableColumn-Tail',
  },
  {
    name: 'Fleet',
    key: 'type',
    sortable: true,
    size: 'xsmall',
    dataCyClassName: 'Ship-ShipSelectTableColumn-Fleet',
  },
  {
    name: 'Created',
    key: 'created',
    sortable: true,
    size: 'small',
    className: styles.tableColumn,
    dataCyClassName: 'Ship-ShipSelectTableColumn-Created',
  },
  {
    name: 'Last Transmission Date',
    key: 'modified',
    sortable: true,
    size: 'small',
    className: styles.tableColumn,
    dataCyClassName: 'Ship-ShipSelectTableColumn-Modified',
  },
  {
    name: 'Flight Number',
    key: 'flightNumber',
    sortable: true,
    size: 'xsmall',
    dataCyClassName: 'Ship-ShipSelectTableColumn-FlightNumber',
  },
  {
    name: 'Opened',
    key: 'opened',
    sortable: true,
    size: 'small',
    dataCyClassName: 'Ship-ShipSelectTableColumn-Opened',
  },
  {
    name: 'Departure',
    key: 'departure',
    sortable: true,
    size: 'xsmall',
    dataCyClassName: 'Ship-ShipSelectTableColumn-Departure',
  },
  {
    name: 'Destination',
    key: 'destination',
    sortable: true,
    size: 'xsmall',
    dataCyClassName: 'Ship-ShipSelectTableColumn-Destination',
  },
];

const idPrefix = 'ShipSelect';

const ShipSelect = (props) => {
  const {
    rAircraftMap,
    rAircraftList,
    fleetFilter,
    onCancel,
    onFleetFilterChange,
    onSelect,
  } = props;

  const filteredAircraftList = (
    !rAircraftList
      ? []
      : !fleetFilter
        ? rAircraftList
        : rAircraftList.filter(
            (aircraft) => aircraft.aircraft_type.id === fleetFilter,
          )
  ).map((aircraft) => {
    const flight = aircraft.getCurrentFlight();
    return {
      id: aircraft.id,
      tail: aircraft.tail,
      type: aircraft.aircraft_type.value.name,
      created: {
        display: aircraft.created
          ? getUTCDateTime(aircraft.created)
          : NOT_AVAILABLE,
        sort: aircraft.created || 0,
      },
      modified: {
        display: aircraft.modified
          ? getUTCDateTime(aircraft.modified)
          : NOT_AVAILABLE,
        sort: aircraft.modified || 0,
      },
      flightNumber: flight?.number || NOT_AVAILABLE,
      opened: {
        display: flight?.open_timestamp
          ? getUTCDateTime(flight.open_timestamp)
          : NOT_AVAILABLE,
        sort: flight?.open_timestamps || 0,
      },
      departure: flight?.departure_airport.value.iata || NOT_AVAILABLE,
      destination: flight?.destination_airport.value.iata || NOT_AVAILABLE,
    };
  });

  return (
    <Row className={styles.root} data-cy-id="ShipSelect" noGutters>
      <Col className={styles.body}>
        <Row className={styles.bodyHeaderRow} noGutters>
          <Col className="title_1">Ship selection</Col>
          <Col md="auto">
            <Button
              className="button_reg"
              data-cy-id="ShipSelect-CancelButton"
              onClick={onCancel}
            >
              Cancel
            </Button>
          </Col>
        </Row>
        <Row
          className={styles.fleetSelectionRow}
          data-cy-id="ShipSelect-FiltersPanel"
          noGutters
        >
          <Col md="auto">
            <Select
              idPrefix={idPrefix}
              data-cy-id="ShipSelect-FiltersPanel-FleetSelect"
              label="Fleet: "
              onChange={({ target: { value } }) => onFleetFilterChange(value)}
              options={AIRCRAFT_TYPE_OPTIONS_W_ALL}
              value={fleetFilter}
            />
          </Col>
        </Row>
        <Row
          className={styles.shipListRow}
          data-cy-id="ShipSelect-ListPanel"
          noGutters
        >
          <Col md="auto" className={styles.tableContainer}>
            <SkyPulseTable
              title="Ship list"
              columns={columns}
              rows={filteredAircraftList}
              onRowClick={(id) => {
                const aircraft = rAircraftMap.get(id);
                onSelect(aircraft);
              }}
              defaultSort="tail"
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

ShipSelect.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

const state = (state) => {
  return {
    rAircraftMap: state.aircraftMap,
    rAircraftList: state.aircraftList,
  };
};

export default connect(state)(ShipSelect);
